import type { FullPageEditorPresetAPI } from '@confluence/full-page-editor-store';

let cancelPending: (() => void) | undefined;

export const cancelLiveDocEditModeSelection = (): void => {
	cancelPending?.();
	cancelPending = undefined;
};

/**
 * Selects a suggestion once the live doc's editor is in edit mode. The panel can remount during
 * the switch, so this waits outside it. The editor clears its selection when its mode changes, so
 * selecting waits a frame for that, which also lets the edit mode layout settle before scrolling
 * to the diff.
 */
export const selectSuggestionInLiveDocEditMode = (
	editorAPI: FullPageEditorPresetAPI | undefined,
	suggestionId: string,
): boolean => {
	cancelLiveDocEditModeSelection();
	const unsubscribe = editorAPI?.editorViewMode?.sharedState.onChange(({ nextSharedState }) => {
		if (nextSharedState?.mode !== 'edit') {
			return;
		}
		cancelLiveDocEditModeSelection();
		const frame = requestAnimationFrame(() => {
			cancelPending = undefined;
			const aiSuggestions = editorAPI?.aiSuggestions;
			if (aiSuggestions?.sharedState.currentState()?.suggestionById.has(suggestionId)) {
				aiSuggestions.actions.selectSuggestion(suggestionId, { interactionPoint: 'sidebar' });
			}
		});
		cancelPending = () => cancelAnimationFrame(frame);
	});
	if (unsubscribe) {
		cancelPending = unsubscribe;
	}
	return unsubscribe !== undefined;
};
